import React, { useContext, useEffect, useState } from 'react';
import './ViewLeaderTour.css';
import { PassengerAPI } from '../../../../../API/PassengerAPIs/PassengerAPIs';
import ViewLeaderTourDetails from './ViewLeaderTourDetails/ViewLeaderTourDetails';
import STC from '../../../../../STCLibrary/STCFactory/STCFactory';
import { IoMdDownload } from 'react-icons/io';
import { format } from 'date-fns';
import { LeaderAPIs } from '../../../../../API/LeaderAPIs/LeaderAPIs';
import { useNavigate } from 'react-router-dom';
import NotificationContext from '../../../../../STCLibrary/NotificationSystem/NotificationContext';
import ApiResponseHandler from '../../../../../STCLibrary/ApiResponseHandler/ApiResponseHandler';


export default function ViewLeaderTour({tourID}){

    const navigate = useNavigate();
    const notificationCtx = useContext(NotificationContext);

    const [loading, setLoading] = useState(true);
    const [tourDetails, setTourDetails] = useState();

    const [downloadingStatement, setDwnStatement] = useState(false);
    const [downloadingPayments, setDwnPayments] = useState(false);

    const getTourDetails = () => {

        PassengerAPI.GetTourDetails(tourID)
        .then((response) => {
            if(response.status === 200){
                setTourDetails(response.data);
                setLoading(false);
            }
        })
        .catch((err) => {
            console.log(err);
            ApiResponseHandler(err.response, notificationCtx, navigate);
        })
    }

    

    const handleDownloadStatement = () => {
        const newWindow = window.open('', '_blank');
        setDwnStatement(true);
        LeaderAPIs.PostDownloadBookingStatement(tourID)
        .then((response) => {
            console.log('Response: ', response)
            const url = URL.createObjectURL(response.data);
            newWindow.location.href = url;
          
        })
        .catch((err) => {
            console.log(err);
            setDwnStatement(false)
        })
        .finally(() => {
            setDwnStatement(false)
        })
    }


    const handleDownloadPayments = () => {
        const newWindow = window.open('', '_blank');
        setDwnPayments(true);
        LeaderAPIs.GetPayments(tourID)
        .then((response)=> {
            console.log(response);
            const url = URL.createObjectURL(response.data);
            newWindow.location.href = url;
 
        })
        .catch((err) => {
            console.log(err);
            setDwnPayments(false);
        })
        .finally(() => {
            setDwnPayments(false);
        })
    }   


    useEffect(() => {
        getTourDetails();
    }, []);

    if(loading){
        return(<div className={'leader-tour-card'}>Loading {tourID}...</div>)
    }
    else{
        return(
            <div className={'leader-tour-card'}>

                <h3>{tourDetails.destinations[0]} - {format(new Date(tourDetails.dateOfTravel), 'LLL yyyy')} </h3>

                {(format(new Date(tourDetails.dateOfTravel), 'T') > format(new Date(), 'T')) ?
                <>                    
                    <div>
                        <ViewLeaderTourDetails tourDetails={tourDetails}/>
                    </div>
                    <div className='leader-tour-info-line'>
                        <div className='m-2'>
                        <STC.Button size='sm' disabled={downloadingStatement} onClick={handleDownloadStatement}>Statement <IoMdDownload/></STC.Button>
                        </div>
                        <div className='m-2'>
                        <STC.Button size='sm' disabled={downloadingPayments} onClick={handleDownloadPayments}>Payments <IoMdDownload/></STC.Button>
                        </div>
                    </div>
                    <STC.Alert variant='warning'>
                        <div className='leader-payments-disclaimer'>Payments are processed every working day before midday and will not show here until this has been done. Payments made outside office hours/over the weekend will be processed the next working day.</div>
                    </STC.Alert>
                    
                </>
                :
                <STC.Alert variant={'danger'}>This tour has been completed.</STC.Alert>
                } 

               
            </div>
        )
    }

}